import React from "react";

/**
 * BRep brand wordmark — matches Byron Performance Coaching visual identity.
 * "BREP" set in Archivo Black with an inner cyan/blue bar motif on the E
 * and a barbell glyph flanking the mark for icon usage.
 *
 * Props:
 *  - size: 'sm' | 'md' | 'lg'   (default 'md')
 *  - withBars: show barbell glyphs beside the wordmark
 */
export default function BrepLogo({ size = "md", withBars = false, className = "" }) {
  const sizes = {
    sm: { text: "text-2xl", bar: "w-3 h-3", gap: "gap-2" },
    md: { text: "text-4xl md:text-5xl", bar: "w-4 h-4", gap: "gap-3" },
    lg: { text: "text-6xl md:text-8xl", bar: "w-6 h-6 md:w-8 md:h-8", gap: "gap-4" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className={`inline-flex items-center ${s.gap} ${className}`} aria-label="BRep">
      {withBars && <BarbellGlyph className={s.bar} />}
      <div className={`font-archivo uppercase leading-none tracking-tight ${s.text} flex items-center`}>
        <span className="text-white">B</span>
        <span className="text-[#2A5BFF]">R</span>
        <span className="relative text-white">
          E
          {/* Center bar accent inside the E to mimic brand logo */}
          <span className="absolute left-[15%] right-[15%] top-1/2 -translate-y-1/2 h-[14%] bg-[#2A5BFF] pointer-events-none" />
        </span>
        <span className="text-white">P</span>
      </div>
      {withBars && <BarbellGlyph className={s.bar} flipped />}
    </div>
  );
}

function BarbellGlyph({ className = "", flipped = false }) {
  return (
    <svg
      viewBox="0 0 32 24"
      className={`${className} ${flipped ? "scale-x-[-1]" : ""}`}
      aria-hidden="true"
    >
      {/* plates */}
      <rect x="0"  y="4"  width="4" height="16" fill="#2A5BFF" />
      <rect x="6"  y="2"  width="4" height="20" fill="#2A5BFF" />
      {/* bar */}
      <rect x="10" y="10" width="22" height="4" fill="#ffffff" />
    </svg>
  );
}
